'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _disclosure = require('./disclosure.js');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _number_utility = require('../../../packages/common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var WeightedAverageMaturityCard = function (_React$Component) {
  _inherits(WeightedAverageMaturityCard, _React$Component);

  function WeightedAverageMaturityCard() {
    _classCallCheck(this, WeightedAverageMaturityCard);

    return _possibleConstructorReturn(this, (WeightedAverageMaturityCard.__proto__ || Object.getPrototypeOf(WeightedAverageMaturityCard)).apply(this, arguments));
  }

  _createClass(WeightedAverageMaturityCard, [{
    key: 'renderCardRows',
    value: function renderCardRows(data, headerLabel) {
      var rows = [];
      if (_collection_utility.CollectionUtility.includes(headerLabel, 'Maturity')) {
        mapIndexed(function (item, i) {
          rows.push(_react2.default.createElement(
            'div',
            { key: i, 'data-testid': 'weighted-average-maturity-row', className: "row-divider category padding-horizontal-0 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'weighted-average-maturity-date', className: 'col-xs-4 col-sm-4 col-md-3 padding-left-0 text-left' },
              _date_formatter2.default.getDateInSpecificFormat(item.date, "MMM-YY")
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'weighted-average-maturity-value', className: 'col-xs-3 col-sm-3 col-md-2 padding-right-0 text-right' },
              _number_utility2.default.convertToAmountWithPreciseRounding(item.wam, 0)
            )
          ));
        }, data);
      }

      if (_collection_utility.CollectionUtility.includes(headerLabel, 'Life')) {
        mapIndexed(function (item, i) {
          rows.push(_react2.default.createElement(
            'div',
            { key: i, 'data-testid': 'weighted-average-maturity-row', className: "row-divider category padding-horizontal-0 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'weighted-average-maturity-date', className: 'col-xs-4 col-sm-4 col-md-3 padding-left-0 text-left' },
              _date_formatter2.default.getDateInSpecificFormat(item.date, "MMM-YY")
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'weighted-average-maturity-value', className: 'col-xs-3 col-sm-3 col-md-2 padding-right-0 text-right' },
              _number_utility2.default.convertToAmountWithPreciseRounding(item.wal, 0)
            )
          ));
        }, data);
      }
      return rows;
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.data)) {
        return null;
      }
      var ariaLabel = "";
      if (!(0, _ramda.isNil)(this.props.headerLabel)) {
        ariaLabel = (0, _functional_utility.isNilOrEmpty)(this.props.headerLabel.key) ? this.props.headerLabel : _string_utility2.default.getLocalizedString(this.props.intl, this.props.headerLabel.props.defaultMessage, this.props.headerLabel.key);
      }
      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card' },
        _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%', onEnter: this.props.activeCardHandler.bind(this, this.props.id) }),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.props.headerLabel,
            headerTitleId: this.props.id,
            breakpoint: this.props.breakpoint,
            headerTitleLabel: "portfolio-child-header"
          },
          _react2.default.createElement(
            'div',
            { className: 'display-table margin-bottom-10 width-100pct' },
            this.renderCardRows(this.props.data, this.props.headerLabel)
          ),
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosureText, placementId: this.props.placementId, arialabel: ariaLabel })
        )
      );
    }
  }]);

  return WeightedAverageMaturityCard;
}(_react2.default.Component);

exports.default = WeightedAverageMaturityCard;